module.exports = require('@bugsnag/browser')



//////////////////
// WEBPACK FOOTER
// ./~/@bugsnag/js/browser/notifier.js
// module id = 8
// module chunks = 0 1